import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { collection, onSnapshot, updateDoc, doc } from "firebase/firestore";

import { db } from "../firebase";
import { LanguageContext } from "../context/LanguageContext";

export default function ManageUsers() {
  const { translate } = useContext(LanguageContext);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "profilsUsers"), (snap) => {
      setUsers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const handleRoleChange = async (userId, newRole) => {
    await updateDoc(doc(db, "profilsUsers", userId), { role: newRole });
  };

  if (loading) return <CircularProgress />;
  return (
    <Box p={2}>
      <Typography variant="h5">{translate("ManageUsers")}</Typography>
      {users.map((u) => (
        <Box key={u.id} display="flex" alignItems="center" mb={2}>
          <Typography style={{ width: 200 }}>{u.email || u.name}</Typography>
          <FormControl size="small">
            <InputLabel>{translate("Role")}</InputLabel>
            <Select
              value={u.role}
              onChange={(e) => handleRoleChange(u.id, e.target.value)}
              label={translate("Role")}
            >
              <MenuItem value="Normal User">{translate("NormalUser")}</MenuItem>
              <MenuItem value="Active User">{translate("ActiveUser")}</MenuItem>
              <MenuItem value="Admin">{translate("Admin")}</MenuItem>
            </Select>
          </FormControl>
        </Box>
      ))}
    </Box>
  );
}
